import gql from 'graphql-tag';

const WAREHOUSE_FRAGMENT = gql`
	fragment warehouse on Warehouse {
		id
		name
		location {
			id
			name
			addressObj {
				id
				region
				street
				city
				postcode
			}
		}
	}
`;

const WAREHOUSE_PRINTER_FRAGMENT = gql`
	fragment warehousePrinter on Warehouse {
		id
		name
		labelPrinterHost
		labelPrinterPort
		labelPrinterConfigurationVersion
		labelPrinterValidatedAt
		labelPrinterReady
		labelPrintBridgeConfigured
		labelPrintBridgeTokenIssuedAt
		labelPrintBridgeId
		labelPrintBridgeVersion
		labelPrintBridgeLastSeenAt
		labelPrinterLastTestJob {
			id
			created
			status
			statusMessage
			printerConfigurationVersion
			completedAt
			failedAt
			uncertainAt
		}
	}
`;

export const GET_WAREHOUSES = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: WarehousePageFilter
	) {
		getWarehouses(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...warehouse
			}
			count
		}
	}
	${WAREHOUSE_FRAGMENT}
`;

export const CREATE_WAREHOUSE = gql`
	mutation createWarehouseMutation($input: CreateWarehouseInput!) {
		createWarehouse(input: $input) {
			id
			name
			location {
				id
				name
			}
		}
	}
`;

export const DESTROY_WAREHOUSE = gql`
	mutation destroyWarehouseMutation ($id: ID!) {
		destroyWarehouse(id: $id)
	}
`;


export const GET_WAREHOUSE = gql`
	query($id: String) {
		getWarehouse(id: $id) {
			...warehouse
			...warehousePrinter
		}
	}
	${WAREHOUSE_FRAGMENT}
	${WAREHOUSE_PRINTER_FRAGMENT}
`;

export const MODIFY_WAREHOUSE = gql`
	mutation modifyWarehouseMutation($input: ModifyWarehouseInput!) {
		modifyWarehouse(input: $input) {
			warehouse {
				...warehouse
			}
		}
	}
	${WAREHOUSE_FRAGMENT}
`;

export const GET_WAREHOUSES_COUNT = gql`
	query {
		countWarehouses
	}
`;

export const CONFIGURE_WAREHOUSE_LABEL_PRINTER = gql`
	mutation ConfigureWarehouseLabelPrinter($warehouseId: ID!, $host: String!, $port: Int!) {
		configureWarehouseLabelPrinter(warehouseId: $warehouseId, host: $host, port: $port) {
			...warehousePrinter
		}
	}
	${WAREHOUSE_PRINTER_FRAGMENT}
`;

export const ROTATE_WAREHOUSE_PRINT_BRIDGE_TOKEN = gql`
	mutation RotateWarehousePrintBridgeToken($warehouseId: ID!) {
		rotateWarehousePrintBridgeToken(warehouseId: $warehouseId) {
			token
			warehouse {
				...warehousePrinter
			}
		}
	}
	${WAREHOUSE_PRINTER_FRAGMENT}
`;

export const REQUEST_WAREHOUSE_PRINTER_TEST_LABEL = gql`
	mutation RequestWarehousePrinterTestLabel($warehouseId: ID!, $operationId: String!) {
		requestWarehousePrinterTestLabel(warehouseId: $warehouseId, operationId: $operationId) {
			id
			created
			status
			statusMessage
			printerConfigurationVersion
			completedAt
			failedAt
			uncertainAt
		}
	}
`;

export const CONFIRM_WAREHOUSE_PRINTER_TEST_LABEL = gql`
	mutation ConfirmWarehousePrinterTestLabel($warehouseId: ID!, $jobId: ID!) {
		confirmWarehousePrinterTestLabel(warehouseId: $warehouseId, jobId: $jobId) {
			...warehousePrinter
		}
	}
	${WAREHOUSE_PRINTER_FRAGMENT}
`;
